// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../../../index.mjs";
export const AuthValues = {
    basic: (value) => {
        return Object.assign(Object.assign({}, value), { type: "basic", _visit: function (visitor) {
                return FernIr.dynamic.AuthValues._visit(this, visitor);
            } });
    },
    bearer: (value) => {
        return Object.assign(Object.assign({}, value), { type: "bearer", _visit: function (visitor) {
                return FernIr.dynamic.AuthValues._visit(this, visitor);
            } });
    },
    header: (value) => {
        return Object.assign(Object.assign({}, value), { type: "header", _visit: function (visitor) {
                return FernIr.dynamic.AuthValues._visit(this, visitor);
            } });
    },
    oauth: (value) => {
        return Object.assign(Object.assign({}, value), { type: "oauth", _visit: function (visitor) {
                return FernIr.dynamic.AuthValues._visit(this, visitor);
            } });
    },
    inferred: (value) => {
        return Object.assign(Object.assign({}, value), { type: "inferred", _visit: function (visitor) {
                return FernIr.dynamic.AuthValues._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "basic":
                return visitor.basic(value);
            case "bearer":
                return visitor.bearer(value);
            case "header":
                return visitor.header(value);
            case "oauth":
                return visitor.oauth(value);
            case "inferred":
                return visitor.inferred(value);
            default:
                return visitor._other(value);
        }
    },
};
